module.exports = __webpack_public_path__ + "media/upload-your-concept.89b34d8c.mp4";